var _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgMailIcon = function SvgMailIcon(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_1992_1",
    "data-name": "Component 1992 \\u2013 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.58,
    height: 14.825,
    viewBox: "0 0 20.58 14.825",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Component_1990_1",
    "data-name": "Component 1990 \\u2013 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1167",
    "data-name": "Path 1167",
    d: "M2,0H18.58a2,2,0,0,1,2,2V12.825a2,2,0,0,1-2,2H2a2,2,0,0,1-2-2V2A2,2,0,0,1,2,0Z",
    fill: "#fff"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_69",
    "data-name": "Group 69",
    transform: "translate(0.078 0.339)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_66",
    "data-name": "Group 66",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63",
    "data-name": "Path 63",
    d: "M328.576,228.836a.452.452,0,0,1-.288-.1l-9.884-8.164a.453.453,0,0,1,.577-.7l9.588,7.918,9.343-8.129a.453.453,0,1,1,.6.684l-9.633,8.383A.455.455,0,0,1,328.576,228.836Z",
    transform: "translate(-318.239 -219.547)",
    fill: "#6f7fa9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_67",
    "data-name": "Group 67",
    transform: "translate(0 5.973)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_64",
    "data-name": "Path 64",
    d: "M318.692,237.6a.454.454,0,0,1-.328-.766l6.912-7.267a.453.453,0,1,1,.657.625l-6.912,7.267A.451.451,0,0,1,318.692,237.6Z",
    transform: "translate(-318.239 -229.425)",
    fill: "#6f7fa9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_68",
    "data-name": "Group 68",
    transform: "translate(12.632 6.071)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_65",
    "data-name": "Path 65",
    d: "M346.467,237.4a.451.451,0,0,1-.321-.133l-6.885-6.9a.454.454,0,1,1,.643-.64l6.884,6.9a.453.453,0,0,1-.321.773Z",
    transform: "translate(-339.129 -229.587)",
    fill: "#6f7fa9"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgMailIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/mail-icon.10fa16ee12044ccf195ff7fc5817b8ed.svg";